<script setup>
import { useI18n } from 'vue-i18n';
import MenuItem from 'components/widgets/conversation/contextMenu/menuItem.vue';

const emit = defineEmits(['scheduleMessage']);

const { t } = useI18n();

const scheduleMessage = () => {
  emit('scheduleMessage');
};
</script>

<template>
  <div class="menu-container">
    <MenuItem
      :option="{
        icon: 'calendar-clock',
        label: t('CONVERSATION.REPLYBOX.SEND_LATER'),
      }"
      variant="icon"
      @click.stop="scheduleMessage"
    />
  </div>
</template>

<style scoped lang="scss">
.menu-container {
  @apply p-1 bg-white dark:bg-slate-900 shadow-xl rounded-md flex flex-col min-w-[180px];

  hr:first-child {
    @apply hidden;
  }

  hr {
    @apply m-1 border-b border-solid border-n-strong;
  }
}
</style>
